import { render, staticRenderFns } from "./laborales.vue?vue&type=template&id=2539900a"
import script from "./laborales.vue?vue&type=script&lang=js"
export * from "./laborales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports